export default __webpack_public_path__ + "static/media/natali-dotan.8af83e34.png";